import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "expanded-wrapper bg-white" }
const _hoisted_2 = { class: "table-wrapper" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "header-label" }
const _hoisted_5 = { key: 0 }

import { onMounted, ref, computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import PostDisbursementChangeRow from "@/components/loan/refi/PostDisbursementChangeRow.vue";
import { PayoffPostDisbursementChangeModel } from "@/models/loans";
import { TableHeader } from "@/models/table";
import {
  isActiveSort,
  getSortArrow,
  sort,
  sortBy,
} from "@/composables/tableUtils";


export default /*@__PURE__*/_defineComponent({
  __name: 'PostDisbursementChangesTable',
  props: {
    postDisbursementChanges: {}
  },
  setup(__props: any) {

const props = __props;

const route = useRoute();
const router = useRouter();

const sortKey = ref<string>("");
const sortOrder = ref<number>(1);

const headers = ref<Array<TableHeader>>([
  { label: "Created Date", sortable: true, key: "createdDate", display: true },
  { label: "Updated By", sortable: true, key: "updatedBy", display: false },
  {
    label: "Post-Disbursement Change Type",
    sortable: true,
    key: "payoffDisbursementStatusReasonHumanized",
    display: false,
  },
  {
    label: "Adjusted Amount",
    sortable: true,
    key: "adjustedAmount",
    display: true,
  },
  {
    label: "Adjusted Fee Amount",
    sortable: true,
    key: "adjustedFeeAmount",
    display: true,
  },
  {
    label: "Processing Date",
    sortable: true,
    key: "processingDate",
    display: true,
  },
  {
    label: "Effective Date",
    sortable: true,
    key: "effectiveDate",
    display: true,
  },
]);

const tableTitle = computed<string>(() =>
  (props.postDisbursementChanges)?.length > 1
    ? "Post-Disbursement Changes"
    : "Post-Disbursement Change"
);

const tableHeaders = computed<Array<TableHeader>>(() =>
  headers.value.filter((t: TableHeader) => t.display)
);

const sortedPostDisbursementChanges = computed(() => {
  if (!sortKey.value) {
    return props.postDisbursementChanges; // no sorting, return original order
  }

  return sort(
    [...props.postDisbursementChanges],
    sortKey.value,
    sortOrder.value
  );
});

function applySortBy(key: string) {
  const sortByResponse = sortBy(sortKey.value, sortOrder.value, key);

  sortKey.value = sortByResponse.sortKey;
  sortOrder.value = sortByResponse.sortOrder;

  router.push({
    query: {
      ...route.query,
      postDisbursementChangeSortKey: sortKey.value,
      postDisbursementChangeSortOrder: sortOrder.value.toString(),
    },
    hash: route.hash,
  });
}

function intializeSorting() {
  const querySortKey = route.query.postDisbursementChangeSortKey as string;
  const querySortOrder = parseInt(
    route.query.postDisbursementChangeSortOrder as string,
    10
  );

  if (querySortKey) {
    sortKey.value = querySortKey;
  }

  if (
    !isNaN(querySortOrder) &&
    (querySortOrder === 1 || querySortOrder === -1)
  ) {
    sortOrder.value = querySortOrder;
  }
}

onMounted(async () => {
  intializeSorting();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h3", null, _toDisplayString(tableTitle.value), 1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("table", null, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tableHeaders.value, (header) => {
              return (_openBlock(), _createElementBlock("th", {
                key: header.key,
                class: _normalizeClass(_unref(isActiveSort)(sortKey.value, header.key)),
                onClick: ($event: any) => (applySortBy(header.key))
              }, [
                _createElementVNode("span", _hoisted_4, [
                  _createTextVNode(_toDisplayString(header.label) + " ", 1),
                  (header.sortable)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_unref(getSortArrow)(sortKey.value, sortOrder.value, header.key)), 1))
                    : _createCommentVNode("", true)
                ])
              ], 10, _hoisted_3))
            }), 128))
          ])
        ]),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedPostDisbursementChanges.value, (postDisbursementChange, index) => {
            return (_openBlock(), _createBlock(PostDisbursementChangeRow, {
              key: `${postDisbursementChange.payoffId}_${index}`,
              postDisbursementChange: postDisbursementChange,
              headers: tableHeaders.value
            }, null, 8, ["postDisbursementChange", "headers"]))
          }), 128))
        ])
      ])
    ])
  ]))
}
}

})